export default {
  hasDashboard: false,
  isFixed: true,
  slug: "apps",
  display: false,
  menus: []
};